import { Button, Modal, ValidationStates } from '@opengov/component-library/dist';
import { IReportLocale } from '@opengov/reporting-app/application/common/locale';
import React, { useEffect, useMemo } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import ReportFormInputs from '../../../forms/reportForm/ReportFormInputs';
import { IReportFormHolder } from '../../../forms/reportForm/types';

import styles from './ChartAndDetailsCopyReportModal.scss';

export interface ICopyReportModalProps extends IReportFormHolder {
  newReport: any;
  reportLocaleText: IReportLocale;
  currentTemplate: any;
  currentReport: any;
  closeModal(): void;
  onCopy(copySavedViews: boolean, copyAccess: ValidationStates, navigate: NavigateFunction): void;
}

export const ChartAndDetailsCopyReportModal = (props: ICopyReportModalProps) => {
  const {
    newReport,
    closeModal,
    reportLocaleText,
    titleState,
    onReportDescriptionBlur,
    onReportDescriptionChange,
    onReportTitleBlur,
    onReportTitleChange,
    onCopy
  } = props;
  const modalTitle = reportLocaleText.copyReport.modalTitle;
  const modalDescription = reportLocaleText.copyReport.modalDescription;
  const defaultTitle = useMemo(() => {
    const title = props.currentTemplate ? props.currentTemplate.standardReportName : props.currentReport?.title;
    // Report creation fails if length of title is > 40, so we make sure that defaultTitle
    // is always <= 30 so that adding `... [COPY]` will not exceed the limit
    return title.length > 30 ? title.slice(0, 30).concat('...') : title;
  }, [props.currentTemplate?.standardReportName, props.currentReport?.title]);
  const navigate = useNavigate();

  useEffect(() => {
    onReportTitleChange(`${defaultTitle} [COPY]`);
  }, [defaultTitle]);

  return (
    <Modal.Work onClose={closeModal} title={modalTitle} description={modalDescription}>
      <div className={styles.modalContentWrapper}>
        <div className={styles.inputContainer}>
          <ReportFormInputs
            onReportDescriptionChange={onReportDescriptionChange}
            onReportDescriptionBlur={onReportDescriptionBlur}
            onReportTitleBlur={onReportTitleBlur}
            onReportTitleChange={onReportTitleChange}
            reportLocaleText={reportLocaleText}
            reportTitleValidationState={titleState}
            reportTitle={newReport.title}
            reportDescription={newReport.description}
          />
        </div>
        <div className={styles.buttons}>
          <Button.Neutral.Default onClick={closeModal} dataTest="copy-report-close-modal-button">
            {reportLocaleText.copyReport.closeModalButton}
          </Button.Neutral.Default>
          <Button.Primary.Default
            onClick={() => {
              onCopy(true, ValidationStates.None, navigate);
            }}
            dataTest="copy-report-confirm-modal-button"
            disabled={titleState === ValidationStates.Error}
          >
            {reportLocaleText.copyReport.confirmButton}
          </Button.Primary.Default>
        </div>
      </div>
    </Modal.Work>
  );
};
